import { SlidersHorizontal } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface AdvancedFilterButtonProps {
  isOpen: boolean;
  activeCount: number;
  onClick: () => void;
}

export function AdvancedFilterButton({ isOpen, activeCount, onClick }: AdvancedFilterButtonProps) {
  const hasActiveFilters = activeCount > 0;

  return (
    <Button
      variant={isOpen || hasActiveFilters ? 'default' : 'outline'}
      size="sm"
      className="h-9 shrink-0 gap-1.5 text-xs duration-200 ease-out"
      onClick={onClick}
    >
      <SlidersHorizontal className="size-3.5" />
      Filters
      {hasActiveFilters && (
        <span className="flex size-4 items-center justify-center rounded-full bg-primary-foreground text-3xs font-bold text-primary motion-safe:animate-in motion-safe:fade-in-0 motion-safe:zoom-in-50">
          {activeCount}
        </span>
      )}
    </Button>
  );
}
